import { useStore } from 'effector-react'
import {
  $strategies,
  $totalCountOfStrategies,
  getStrategies,
  strategiesMounted,
} from './model'
import { StrategiesRequest } from './types'

export const useStrategies = () => {
  const onChangeStrategiesList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    filters,
  }: StrategiesRequest) => {
    strategiesMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
      filters,
    })
  }

  const loading = useStore(getStrategies.pending)

  const strategies = useStore($strategies)
  const totalCountOfStrategies = useStore($totalCountOfStrategies)
  return {
    strategies,
    totalCountOfStrategies,
    loading,
    onChangeStrategiesList,
  }
}
